import { Pipe, PipeTransform } from '@angular/core';
import { Address } from '@eceos/domain';

@Pipe({
  name: 'address'
})
export class AddressPipe implements PipeTransform {
  transform(value: Address): string {
    return value.fullAddress;
  }
}
